import React, { useEffect, useState, Fragment } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const getRandomData = () => new Array(7).fill(0).map(() => Math.floor(Math.random() * 100));

const getState = (dataIndicador, dataIndicador2, titleData, titleData2) => {
  let resumeIndicator = {
    labels: getFilterNamesData(dataIndicador),
    datasets: [
      {
        label: titleData,
        backgroundColor: '#55e5bb',
        borderColor: '#55e5bb',
        borderWidth: 1,
        hoverBackgroundColor: '#55e5bb',
        hoverBorderColor: '#55e5bb',
        data: getRejectsDataNumber(dataIndicador),
      },
      {
        label: titleData2,
        backgroundColor: '#3EA3FC',
        borderColor: '#3EA3FC',
        borderWidth: 1,
        hoverBackgroundColor: '#3EA3FC',
        hoverBorderColor: '#3EA3FC',
        data: getRejectsDataNumber(dataIndicador2),
      },

    ],
  }
  return resumeIndicator;
};

const options = {
  legend: {
    position: 'bottom',
    scales: {
      x: {
        ticks: {
          maxRotation: 0,
          minRotation: 0
        }
      },
      y: {
        ticks: {
          maxRotation: 0,
          minRotation: 0
        }
      }
    }
  }
};

const getFilterNamesData = (dataIndicator) => {
  let arrMes = [];
  for (let i = 0; i < dataIndicator.length; i++) {
    let mes = `${dataIndicator[i].asunto}`;
    arrMes.push(mes);
  }
  return arrMes;
}

const getRejectsDataNumber = (dataIndicator) => {
  let arrDataNumber = [];
  for (let i = 0; i < dataIndicator.length; i++) {
    arrDataNumber.push(dataIndicator[i].cantidad);
  }
  return arrDataNumber;
}

const AnimatedBarComplaintsAndClaims = ({ dataIndicator, dataIndicator2, titleData, titleData2 }) => {

  const [data, setData] = useState(null);

  useEffect(() => {
    getDataIndicator(dataIndicator, dataIndicator2, titleData, titleData2);
  }, []);

  const getDataIndicator = async (dataIndicator, dataIndicator2, titleData, titleData2) => {
    let dataInd = await getState(dataIndicator, dataIndicator2,titleData, titleData2);
    setData(dataInd);
  }

  return (
    <Fragment>
      {data != null ? <Bar data={data} options={options} /> : null}
    </Fragment>
  );
};

export default AnimatedBarComplaintsAndClaims;
